import { Close, LocationOn } from '@mui/icons-material'

export interface VenueRowSpace {
  id: string
  title: string
  venueName: string
  images: string[]
  location: { city: string; country: string }
}

interface Props {
  space: VenueRowSpace
  onRemove?: () => void
  badge?: string
}

const VenueRow = ({ space, onRemove, badge }: Props): JSX.Element => (
  <div
    className={`flex items-stretch gap-3 h-[72px] bg-white border border-[#8c8c8c] rounded-lg
      overflow-hidden`}>
    <div className='w-12 h-full shrink-0 bg-[#f0f0f0]'>
      {space.images[0] && (
        <img src={space.images[0]} alt='' className='w-full h-full object-cover' />
      )}
    </div>
    <div className='flex-1 min-w-0 flex flex-col justify-center'>
      <p className='text-sm font-medium text-[#1a1a1a] truncate'>{space.title}</p>
      {space.venueName && space.venueName !== space.title && (
        <p className='text-xs text-[#595959] truncate'>{space.venueName}</p>
      )}
      <div className='flex items-center gap-1'>
        <LocationOn className='size-3! text-[#8c8c8c]' />
        <p className='text-xs text-[#8c8c8c] truncate'>
          {space.location.city}, {space.location.country}
        </p>
      </div>
    </div>
    {onRemove ? (
      <button
        type='button'
        onClick={onRemove}
        className='self-center shrink-0 p-2 !pr-2 cursor-pointer'
        aria-label={`Remove ${space.title}`}>
        <Close className='size-4! text-[#8c8c8c]' />
      </button>
    ) : (
      badge && (
        <span
          className={`self-center shrink-0 mr-2 px-2 py-1 rounded-full bg-[#f5f5f5]
            text-[10px] font-semibold text-[#595959] whitespace-nowrap`}>
          {badge}
        </span>
      )
    )}
  </div>
)

export default VenueRow
